import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//用户个人信息
export function parkingTime(data) {
 
    return fetch({
        url: config.WEB_PARKINGTIME_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}
